import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import { getUniqueRolesByName } from './utils';
import * as plugin from '../plugin/redux/actions';
import * as actions from './redux/actions';
import { drapcodeIcon } from '../../common/custom/icon-library';
import { toast } from 'react-toastify';
export class GenerateLayouts extends Component {
  static propTypes = {
    aiPromptBuilder: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    collections: PropTypes.object.isRequired,
    plugin: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  handleNavigation = (layoutType) => {
    const { history, match, location } = this.props;
    const { projectId, version } = match.params;
    const { state = {} } = location;
    const { userPrompt, roles } = state;

    let path = '';
    switch (layoutType) {
      case 'figma':
        path = `/ai-prompt-builder/${version}/v/${projectId}/figma-to-layouts`;
        break;
      case 'Image':
        path = `/ai-prompt-builder/${version}/v/${projectId}/Image-to-layouts`;
        break;
      default:
        return;
    }
    history.push({
      pathname: path,
      state: { userPrompt, roles: roles },
    });
  };
  state = {
    loading: false,
    systemRoles: [],
  };
  async componentDidMount() {
    const { match, plugin } = this.props;
    const { projectId, version } = match.params;
    const systemRoles = await plugin.loadRoles({ projectId, version });
    const uniqueSystemRoles =  getUniqueRolesByName(systemRoles.data);
    this.setState({ systemRoles: uniqueSystemRoles });
  }
  handleDefaultLayout = async () => {
    const { match, history, location, actions } = this.props;
    const { projectId, version } = match.params;
    const { state = {} } = location;
    const { userPrompt, roles } = state;
    this.setState({ loading: true });
    try {
      const args = {
        projectId: projectId,
        projectVersion: version,
        systemRoles: this.state.systemRoles,
      };
      await actions.generateDefaultLayouts(args);
      toast.success(' Default Layout generated successfully!');
      this.setState({ loading: false });
      history.push({
        pathname: `/on-boarding/${version}/v/${projectId}/global-theme`,
        state: { userPrompt, roles: roles, AiProject: true },
      });
    } catch (error) {
      console.log('error');
      toast.error('Something went wrong');
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { match } = this.props;
    const { projectId, version } = match.params;
    if (!projectId || !version) return null;
    return (
      <CommonPageComponent>
        <ParentContentCard title="Generate Layouts" icon="link">
          <div className="container mt-2">
            <h3 className="mb-4 text-center">Select Layout Generation Type</h3>
            <div className="row justify-content-center g-4">
              <div className="col-md-5">
                <div
                  className="card layout-card border-primary shadow-lg p-4 mb-4"
                  style={{
                    cursor: 'pointer',
                    minHeight: '200px',
                    borderRadius: '1.5rem',
                    transition: 'transform .2s',
                  }}
                  onClick={() => this.handleNavigation('figma')}
                  onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.04)')}
                  onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                >
                  <div className="card-body text-center">
                    <h5 className="card-title mb-3" style={{ fontSize: '1.6rem', fontWeight: 700 }}>
                      <i className={`wb ${drapcodeIcon('section')}`}></i>&nbsp;Figma To Layout&nbsp;
                    </h5>
                    <p className="card-text" style={{ fontSize: '1.1rem' }}>
                      Generate layouts directly from a Figma design.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-5">
                <div
                  className="card layout-card border-secondary shadow-lg p-4 mb-4"
                  style={{
                    cursor: 'pointer',
                    minHeight: '200px',
                    borderRadius: '1.5rem',
                    transition: 'transform .2s',
                  }}
                  onClick={() => this.handleNavigation('Image')}
                  onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.04)')}
                  onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                >
                  <div className="card-body text-center">
                    <h5 className="card-title mb-3" style={{ fontSize: '1.6rem', fontWeight: 700 }}>
                      <i className={`wb ${drapcodeIcon('image')}`}></i>&nbsp;Image To Layout&nbsp;
                    </h5>
                    <p className="card-text" style={{ fontSize: '1.1rem' }}>
                      Convert image or screenshot into structured layouts.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ParentContentCard>
        <div className="text-right mt-3">
          <button
            type="submit"
            className={`btn ${this.state.loading ? 'btn-default' : 'btn-theme-submit'} btn-md`}
            onClick={this.handleDefaultLayout}
            disabled={this.state.loading}
          >
            <i className="wb webconnect-rocket"></i> &nbsp;Generate Default Layout
          </button>
        </div>
      </CommonPageComponent>
    );
  }
}
/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    aiPromptBuilder: state.aiPromptBuilder,
    plugin: state.plugin,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    plugin: bindActionCreators({ ...plugin }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GenerateLayouts);
